import { gate } from 'hub-http/gates';
export const CAMPAIGN_BUSINESS_UNIT = 'campaign-business-unit';
export const CONVERSATIONS_HELPDESK = 'Conversations:HelpDesk';
export const WAIT_UNTIL_EMAIL_EVENT_MIGRATION = 'Workflows:WaitUntil:EmailEventMigration';

// Gates related to FLP enforcement: https://issues.hubspotcentral.com/browse/AUTOPG-3486
export const ENFORCE_FIELD_LEVEL_PERMISSIONS = 'Automation:EnforceFieldLevelPermissions';
export const SENSITIVE_DATA_PHASE_TWO = gate('Automation:SensitiveDataPhase2');
export const SUPPORT_SELECTING_SENSITIVE_PROPERTIES = gate('Automation:SupportSelectingSensitiveProperties');
export const ROUTING_ROTATE_TICKET_OWNER = gate('Routing:RotateTicketOwner');
export const QUICK_ADD_ACTION = gate('Workflows:QuickAddAction');